export const PROJECT_NAME = 'data'

export const PROJECT_URL = `https://udn.com/newmedia/election2020/${PROJECT_NAME}`

// export const DEFAULT_YEAR = '2016'
export const DEFAULT_YEAR = '2020'

// export const DISABLE_YEARS = [ '2020' ]
export const DISABLE_YEARS = []

// 2020 總統、立委
// 2018 地方首長
// 2016 總統、立委
// 2014 地方首長
// 2012 總統、立委
// 2010 地方首長
// 2008 總統、立委
// 2006 地方首長
// 2004 總統、立委
// 2002 地方首長
// 2000 總統、立委 (標題顯示 2001)
export const ELECTION_YEARS = [
  '2020',
  '2018',
  '2016',
  '2014',
  '2012',
  '2010',
  '2008',
  '2006',
  '2004',
  '2002',
  '2000'
]

export const ELECTION_NAV_CONFIG = ELECTION_YEARS
  .map(year => {
    const disable = DISABLE_YEARS.indexOf(year) !== -1
    const defaultEntry = (year === DEFAULT_YEAR)
    return {
      year,
      disable,
      defaultEntry
    }
  })

export const PARTY_COLORS = {
  none: '#d3d3d3',
  dpp: '#009f42',
  kmt: '#0d3587',
  pfp: '#ec631d',
  new: '#f5d423',
  others: '#a1a1a1'
}

export const PARTY_LIGHTEN_COLORS = {
  dpp: '#a5d5b9',
  kmt: '#8ea3ce',
  others: '#d5d5d5'
}

export const PARTY_TABLE_COLORS = {
  none: '#f8f8f8',
  dpp: '#e3efe8',
  kmt: '#e1e4ee',
  pfp: '#ecdbd3',
  new: '#f5efd1',
  others: '#e9e9e9'
}

export const MAP_TABLE_COLORS = {
  none: 'rgba(248, 248, 248, 0.8)',
  dpp: 'rgba(227, 239, 232, 0.8)',
  kmt: 'rgba(225, 228, 238, 0.8)',
  pfp: 'rgba(236, 219, 211, 0.8)',
  new: 'rgba(245, 239, 209, 0.8)',
  others: 'rgba(233, 233, 233, 0.95)'
}

export const PARTY_NAMES = {
  none: '無黨籍',
  dpp: '民進黨',
  kmt: '國民黨',
  pfp: '親民黨',
  new: '新黨',
  others: '其他'
}

export const COUNTY_NAMES_CH2EN_MAPPING = {
  '臺北市': 'taipei',
  '新北市': 'newtaipei',
  '臺北縣': 'newtaipei',
  '基隆市': 'keelung',
  '桃園市': 'taoyuan',
  '桃園縣': 'taoyuan',
  '新竹市': 'hsinchu',
  '新竹縣': 'hsinchu-county',
  '苗栗縣': 'miaoli',
  '臺中市': 'taichung',
  '臺中縣': 'taichung-county',
  '彰化縣': 'changhua',
  '南投縣': 'nantou',
  '雲林縣': 'yunlin',
  '嘉義市': 'chiayi',
  '嘉義縣': 'chiayi-county',
  '臺南市': 'tainan',
  '臺南縣': 'tainan-county',
  '高雄市': 'kaohsiung',
  '高雄縣': 'kaohsiung-county',
  '屏東縣': 'pingtung',
  '宜蘭縣': 'ilan',
  '花蓮縣': 'hualien',
  '臺東縣': 'taitung',
  '金門縣': 'kinmen',
  '澎湖縣': 'penghu',
  '連江縣': 'lianjiang'
}

export default {
  PROJECT_NAME,
  PROJECT_URL,
  ELECTION_YEARS,
  ELECTION_NAV_CONFIG,
  PARTY_COLORS,
  PARTY_LIGHTEN_COLORS,
  PARTY_TABLE_COLORS,
  MAP_TABLE_COLORS,
  PARTY_NAMES,
  COUNTY_NAMES_CH2EN_MAPPING
}
